import React from 'react';

import SectionLayout from 'dpl/quiz/components/SectionLayout';
import QuizSubmitDisclaimer from 'dpl/adoption_application/components/QuizSubmitDisclaimer';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';

export default function PasswordSection(props) {
  return (
    <div className={SECTION_CLASSES}>
      <div className="w-100">
        <SectionLayout {...props} />
        <div className="ph5">
          <QuizSubmitDisclaimer />
        </div>
      </div>
    </div>
  );
}
